export enum EmailDeliveryTab {
  SENT = 'sent',
  PENDING = 'pending',
  FAILED = 'failed',
}
